module.exports = {
    baseUrl: window.env.baseUrl,
    clientId: 'b69f4a39-d903-4e8d-95de-560241fe1575',
    secretId: 'c8034130-4cdc-447b-addc-b055750177d'
}

